<template>
  <div class="container">
    <div class="header">
      <el-row class="header-row">
        <el-col :span="3" :offset="1">
          <div class="logo" @click="toHomePage">
            <el-image
                :src="require('../assets/icon/logo.svg')"
                class="diboLogo"
            ></el-image>
            <el-image
                :src="require('../assets/icon/dibo.svg')"
                class="diboText"
            ></el-image>
          </div>
        </el-col>
        <el-col :span="15" :offset="1">
          <el-menu
              :default-active="activeIndex"
              mode="horizontal"
              :router="true"
          >
            <!--            <el-menu-item index="/HomePage"><a href="#coreCompetence">核心能力</a></el-menu-item>-->
            <el-menu-item index="/HomePage">核心能力</el-menu-item>
            <el-menu-item index="/ability"
            ><a href="#ability">行业赋能</a></el-menu-item
            >
            <el-submenu index="">
              <template slot="title">主打产品</template>
              <el-menu-item index="">
                <a href="https://www.diboot.com"  target="_blank">
                  diboot 低代码开发平台
                </a>
              </el-menu-item>
              <el-menu-item index="">
                <a href="https://www.diboot.com/guide/workflow/introduce.html"  target="_blank">
                  diboot-workflow 工作流
                </a>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="/cooperation"
            ><a href="#cooperation">合作共赢</a></el-menu-item
            >
            <el-menu-item index="/AboutUs">关于我们</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="4">
          <div class="loginButton">
            <el-button plain>登录</el-button>
            <el-button type="primary">免费注册</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <router-view></router-view>

    <div class="footer">
      <div class="wxCode">
        <span>微信扫码联系</span>
        <el-image
            fit="fit"
            style="width:120px;height:120px"
            :src="require('../assets/icon/wx.svg')"
        ></el-image>
      </div>
      <div class="footer-content">
        <br>
        <div>公司地址 : 苏州园区启迪时尚科技城38栋</div>
        <div>合作 : cooperation@dibo.ltd</div>
        <div>服务支持 : service@dibo.ltd</div>
        <div>©2015-2022 苏州帝博信息技术有限公司 | <a target="_blank" href="https://beian.miit.gov.cn" style="color: #fff;">苏ICP备15013001号</a>
        </div>
      </div>
    </div>
    <el-image
        :src="require('../assets/icon/backgroundTop.svg')"
        class="containerImg"
    ></el-image>

    <el-image
        :src="require('../assets/icon/uspensionRobot.png')"
        class="uspensionRobotImg"
        @click="showDrawer"
    ></el-image>

    <div class="drawer" :class="{ drewerShow: isShowDrawer }">
      <div class="top">
        <el-image
            :src="require('../assets/icon/uspensionRobot.png')"
            class="robot"
        ></el-image>
        <i class="el-icon-close iconClose" @click="isShowDrawer = false"></i>
      </div>
      <div class="bottom">
        <div>联系电话 : 13701072224</div>
        <div>合作 : cooperation@dibo.ltd</div>
        <div>服务支持 : service@dibo.ltd</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      activeIndex: "/HomePage",
      isShowDrawer: false
    };
  },
  watch: {
    '$route'(to) {
      this.activeIndex = to.path;
      window.pageYOffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0

    }
  },
  created() {
    this.activeIndex = this.$route.path;
  },
  mounted() {
    let headerRow = document.querySelector(".header-row");
    let headerButtons = headerRow.querySelectorAll(".el-button");
    window.onscroll = function () {
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;

      if (scrollTop >= 60) {
        headerRow.classList.add("headerColor");
        headerButtons[0].classList.add("firstButtonColor");
        headerButtons[1].classList.add("lastButtonColor");
      } else {
        headerRow.classList.remove("headerColor");
        headerButtons[0].classList.remove("firstButtonColor");
        headerButtons[1].classList.remove("lastButtonColor");
      }
    };
  },
  methods: {
    showDrawer() {
      this.isShowDrawer = true;
    },
    toHomePage() {
      this.$router.push('/HomePage')
    }
  }
};
</script>
<style scoped lang="less">
a {
  text-decoration: none;
  display: inline-block;
  color: #000;
}

.headerColor {
  background-color: #fff;
}

.firstButtonColor {
  border: 1px solid #dcdfe6 !important;
  color: #000 !important;
}

.lastButtonColor {
  background-color: #409eff !important;
  border: 1px solid #409eff !important;
  color: #fff !important;
}

.container {
  height: 100%;
  position: relative;
  padding-top: 60px;

  .containerImg {
    position: absolute;
    z-index: 1;
    width: 54%;
    top: 0;
    right: 0;
  }
}

.header {
  width: 100%;
  height: 60px;
  display: flex;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;

  .header-row {
    width: 100%;
    z-index: 999;
    transition: all 0.3s;

    &:hover {
      background-color: #fff;

      .el-button:first-child {
        border: 1px solid #dcdfe6;
        color: #000;
      }

      .el-button:last-child {
        background-color: #409eff;
        border: 1px solid #409eff;
        color: #fff;
      }
    }
  }

  .logo {
    display: flex;
    margin-top: 10px;
    cursor: pointer;

    .diboLogo {
      width: 40px;
    }

    .diboText {
      margin-left: 10px;
      display: flex;
      align-items: center;

      /deep/ .el-image__inner {
        /*width: 70%;*/
        /*height: 70%;*/
      }
    }
  }

  .loginButton {
    display: none;
    text-align: center;
    margin-top: 10px;

    .el-button {
      background-color: rgba(0, 0, 0, 0);
      border: 1px solid #fff;
      color: #fff;
      transition: all 0.3s;

      &:first-child:hover {
        background-color: #ecf5ff;
      }

      &:last-child:hover {
        background-color: #66b1ff;
      }
    }
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 5px solid #55bafa;
    border-radius: 2.5px;
    color: #55bafa;
  }

  .el-menu {
    background-color: rgba(255, 255, 255, 0);

    /deep/ .el-submenu__title {
      color: #000;
      font-size: 16px;
    }

    /*.el-submenu:hover {*/

    /*}*/
    /*/deep/ .el-menu--horizontal {*/
    /*    .el-menu-item:hover {*/
    /*        color: pink !important;*/
    /*    }*/
    /*}*/

    .el-menu-item * {
      vertical-align: baseline !important;
    }

    .el-menu-item {
      margin: 0 35px;
      font-size: 16px;
      color: #000;
      padding: 0;

      &:hover {
        color: #55bafa;
        background-color: rgba(0, 0, 0, 0);
      }
    }
  }
}

.footer {
  height: 180px;
  background-color: #3d5286;
  position: relative;
  padding-top: 25px;
  padding-bottom: 25px;

  .wxCode {
    width: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: absolute;
    left: 0;
    top: 20px;

    span {
      color: #fff;
      margin-bottom: 15px;
    }

    .el-image {
      padding: 15px;
      background-color: #fff;
    }
  }

  .footer-content {
    color: #fff;
    text-align: center;
    letter-spacing: 1px;

    div {
      margin-top: 10px;

      &:last-child {
        font-size: 12px;
        margin-top: 45px;
      }
    }
  }
}

.uspensionRobotImg {
  position: fixed;
  width: 5%;
  right: 3%;
  bottom: 7%;
  cursor: pointer;
  z-index: 999;
  transition: all 0.3s;

  &:hover {
    transform: scale(1.2);
  }
}

.drawer {
  position: fixed;
  right: -300px;
  bottom: 20px;
  width: 300px;
  height: 500px;
  z-index: 2020;
  background-color: #fff;
  border-radius: 10px;
  transition: all 0.3s;
  box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.13);

  .top {
    height: 60px;
    display: flex;
    justify-content: space-between;
    border-radius: 10px 10px 0 0;
    align-items: center;
    background-color: #415990;

    .robot {
      width: 50px;
      height: 50px;
      margin-left: 10px;
    }

    .iconClose {
      font-size: 30px;
      margin-right: 10px;
      cursor: pointer;
      color: #fff;
    }
  }

  .bottom {
    div {
      width: 80%;
      margin: 20px auto;
      text-align: center;
      padding: 20px 0;
      border: 1px solid #6cc87b;
      border-radius: 20px;
    }
  }
}

.drewerShow {
  transform: translateX(-320px);
}
</style>

